import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IEntityAddressModel } from '@apps-common/types/management/entity-address'

export const createAddress = async (model: IEntityAddressModel): Promise<IEntityAddressModel> =>
  axios.post(`/management/address/addaddress`, model).then((res) => res?.data?.data)

type Props = {
  model: IEntityAddressModel
}

export const useManagementCreateAddress = (notify?: boolean, onSuccess?: (data: IEntityAddressModel) => void) =>
  useMutation({
    mutationKey: ['createAddress'],
    mutationFn: ({ model }: Props) => createAddress(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Created address.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to create address, please try again.')
      }
    },
    throwOnError: false
  })
